import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { QuestionCard } from "../common";

const questionOptions = [
  { value: "nhs", label: "The NHS in England" },
  {
    value: "parliamentary",
    label: "A UK government department or other public organisation",
  },
  { value: "neither", label: "Neither of these" },
];

export const Question1 = ({
  updateQuestion,
  updateJurisdiction,
  setNhsComplaint,
  answer,
  updateAnswer,
}) => {
  const [selection, setSelection] = useState(answer || "");

  const navigate = useNavigate();

  const handleSelectionChange = (value) => {
    setSelection(value);
    updateAnswer(value);
    sessionStorage.setItem("answer_q1", value);
    if (value !== "neither") {
      updateJurisdiction(value);
      if (value === "nhs" || value === "parliamentary") {
        setNhsComplaint(value === "nhs");
      }
    }
  };

  const isNextDisabled = selection === "" || !selection;

  const handleNext = () => {
    if (selection === "neither") {
      navigate("/cannot-help", { state: { contentKey: "q1_neither" } });
    } else {
      updateQuestion(2);
    }
  };

  return (
    <QuestionCard
      question="To start with, please tell us what is your complaint about?"
      options={questionOptions}
      required={true}
      selectedValue={selection}
      onChange={handleSelectionChange}
      onNext={handleNext}
      showPrevious={false}
      nextDisabled={isNextDisabled}
      name="complaint-type"
    />
  );
};

Question1.propTypes = {
  updateJurisdiction: PropTypes.func,
  updateQuestion: PropTypes.func,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
};
